import React from "react";
import SiteSeoDashboard from "@/pages/SiteSeoDashboard";

const TechDashboard = () => {
  return <SiteSeoDashboard />;
};

export default TechDashboard;
